import {  Injectable } from "@angular/core"
import { initializeSdk, paymentSdk, PaymentSDKPayParams, PaymentSDKResult } from "@paymentplatform/paymentwebsdk"

type PaymentSDKListeners = {
  onLoad?: () => void
  onError?: (error?: Event) => void
  onClose?: (event: any) => void // Todo: fix: type
}

type PayParams = {
  payObj: PaymentSDKPayParams
  listeners?: PaymentSDKListeners
}

@Injectable({
  providedIn: 'root'
})
export class PaymentSdkService {
  private lastPaymentRef: PaymentSDKResult | null = null

  constructor() {
    initializeSdk({
      cardPaymentOptions: {
        skipLandingPage: true,
        themeConfig: {}
      }
    })
  }

  async pay({ payObj, listeners }: PayParams) {
    this.lastPaymentRef = await paymentSdk().pay(payObj)

    const onLoad = () => {
      listeners?.onLoad?.()
    }

    const onError = (error?: Event) => {
      listeners?.onError?.(error)
    }

    const onClose = (event: any) => {
      listeners?.onClose?.(event)
    }

    this.lastPaymentRef.addEventListener('load', onLoad)
    this.lastPaymentRef.addEventListener('error', onError)
    this.lastPaymentRef.addEventListener('close', onClose)

    return () => {
      this.lastPaymentRef?.removeEventListener('load', onLoad)
      this.lastPaymentRef?.removeEventListener('error', onError)
      this.lastPaymentRef?.removeEventListener('close', onClose)
    }
  }
}
